import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { fromDeactivateAccountActions } from '../actions';

export const deactivateAccountFeatureKey = 'deactivateAccount';

export interface DeactivateAccountState {
  loadDeactivateAccountResponse: string;
  loadDeactivateAccountFailure: IGenericError<ErrorResponse>;
}

export const initialState: DeactivateAccountState = {
  loadDeactivateAccountResponse: undefined,
  loadDeactivateAccountFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromDeactivateAccountActions.loadDeactivateAccountsSuccess, (state, action) => ({
    ...state,
    loadEditUserRoleRequest: action.response
  })),
  on(fromDeactivateAccountActions.loadDeactivateAccountsFailure, (state, action) => ({
    ...state,
    loadEditUserRoleResponse: action.error
  }))
);
